const lang = {
    en : {
        search : 'Search',
        gptSearchPlaceholder : 'What would you like to watch today ?',
        submit : 'Submit',
        gptApiKeyPlaceHolder : 'Enter your Open AI GPT Key'
    },
    hindi : {
        search : 'खोज',
        gptSearchPlaceholder : 'आज आप क्या देखना चाहेंगे?',
        submit : 'जमा करें',
        gptApiKeyPlaceHolder : 'अपना ओपन एआई जीपीटी कुंजी दर्ज करें'
    },
    spanish : {
        search : 'Buscar',
        gptSearchPlaceholder : '¿Qué te gustaría ver hoy?',
        submit : 'Entregar',
        gptApiKeyPlaceHolder : 'Ingrese su clave GPT de Open AI'
    }
}

export default lang